import React from 'react';
import { Outlet, NavLink } from 'react-router-dom';
import { LayoutDashboard, Users, Receipt, Banknote, SlidersHorizontal, Megaphone, BarChart3, LogOut, Gift, Trophy, Plug, ShieldCheck } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';
import { ThemeToggle } from '@/components/ThemeToggle';
import { BrandLogo } from '@/components/BrandLogo';

const links = [
  { to: '/admin', end: true, icon: LayoutDashboard, label: 'Genel Bakış', testid: 'admin-nav-overview' },
  { to: '/admin/mimarlar', icon: Users, label: 'Mimarlar', testid: 'admin-nav-architects' },
  { to: '/admin/satislar', icon: Receipt, label: 'Satışlar', testid: 'admin-nav-sales' },
  { to: '/admin/hakedis', icon: Banknote, label: 'Hakediş', testid: 'admin-nav-payouts' },
  { to: '/admin/kampanyalar', icon: Megaphone, label: 'Kampanyalar', testid: 'admin-nav-campaigns' },
  { to: '/admin/oduller', icon: Trophy, label: 'Ödüller & Seviye', testid: 'admin-nav-rewards' },
  { to: '/admin/davet', icon: Gift, label: 'Davet & Kulüp', testid: 'admin-nav-referrals' },
  { to: '/admin/raporlar', icon: BarChart3, label: 'Raporlar', testid: 'admin-nav-reports' },
  { to: '/admin/pos', icon: Plug, label: 'POS & API', testid: 'admin-nav-pos' },
  { to: '/admin/yoneticiler', icon: ShieldCheck, label: 'Yöneticiler', testid: 'admin-nav-admins' },
  { to: '/admin/parametreler', icon: SlidersHorizontal, label: 'Parametreler', testid: 'admin-nav-params' },
];

export default function AdminLayout() {
  const { logout } = useAuth();
  return (
    <div className="min-h-screen bg-page flex flex-col md:flex-row">
      {/* Sidebar */}
      <aside className="md:w-64 bg-ground text-ink border-b md:border-b-0 md:border-r border-line md:min-h-screen md:sticky md:top-0">
        <div className="p-6 border-b border-line flex items-start justify-between">
          <div>
            <BrandLogo className="text-ink mb-1 block" />
            <p className="font-serif text-lg">Yönetim Paneli</p>
          </div>
          <div className="flex items-center gap-1">
            <ThemeToggle className="-mr-1 -mt-1" />
            <button onClick={logout} data-testid="admin-logout-mobile" aria-label="Çıkış Yap"
              className="md:hidden p-2 -mt-1 rounded-md text-ink-soft hover:text-ink hover:bg-ink/5">
              <LogOut strokeWidth={1.5} className="w-5 h-5" />
            </button>
          </div>
        </div>
        <nav className="p-3 flex md:flex-col gap-1 overflow-x-auto">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={l.testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-2.5 rounded-md text-sm whitespace-nowrap transition-colors ${isActive ? 'bg-ink/10 text-ink font-medium' : 'text-ink-soft hover:text-ink hover:bg-ink/5'}`
              }
            >
              <l.icon strokeWidth={1.25} className="w-4 h-4" />
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 md:mt-auto border-t border-line hidden md:block">
          <button onClick={logout} className="w-full flex items-center gap-3 px-4 py-2.5 rounded-md text-sm text-ink-soft hover:text-ink hover:bg-ink/5" data-testid="admin-logout">
            <LogOut strokeWidth={1.25} className="w-4 h-4" /> Çıkış Yap
          </button>
        </div>
      </aside>

      <main className="flex-1 p-6 md:p-10 max-w-6xl">
        <Outlet />
      </main>
    </div>
  );
}
